import { clearAnalyticsUser } from '../services/analyticsService';
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import LoginModal from './LoginModal';
import { useConsultationModal } from '../contexts/ConsultationModalContext';

const navItems = [
  ['/services', 'Services'],
  ['/projects', 'Projects'],
  ['/about-us', 'About'],
  ['/reviews', 'Reviews'],
  ['/guides', 'Guides'],
  ['/contact', 'Contact']
];

export default function SiteHeader({ showWordmark = false }) {
  const [open, setOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { openConsultationModal } = useConsultationModal();

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
      if (storedUser) setUser(JSON.parse(storedUser));
    } catch (error) {
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
    }
  }, []);

  const handleLogin = (authenticatedUser) => {
    setUser(authenticatedUser);
    setLoginOpen(false);
    setOpen(false);
    navigate('/admin');
  };

  const handleLogout = () => {
    clearAnalyticsUser();
    localStorage.removeItem('user');
    localStorage.removeItem('user_roles');
    localStorage.removeItem('jwt_token');
    sessionStorage.removeItem('user');
    setUser(null);
    setOpen(false);
    navigate('/');
  };

  return (
    <>
      <header className="site-header">
        <a className="skip-link" href="#main-content">Skip to content</a>
        <div className="announcement">
          <span>Maricopa’s local renovation team</span>
          <a href={`tel:${SITE_CONFIG.BUSINESS.PHONE_E164}`}>{SITE_CONFIG.BUSINESS.PHONE}</a>
        </div>
        <div className="nav-shell">
          <Link className="brand" to="/" aria-label="Maricopa Renovations home" onClick={() => setOpen(false)}>
            <img src={SITE_CONFIG.ASSETS.LOGO} alt="Maricopa Renovations" width="92" height="92" />
            {showWordmark && <span className="brand-wordmark" aria-hidden="true"><strong>Maricopa</strong><span>Renovations</span><small>Flooring & more</small></span>}
          </Link>
          <button className="menu-button" type="button" aria-expanded={open} aria-controls="site-navigation" onClick={() => setOpen(!open)}>
            <span className="menu-lines" aria-hidden="true"><i /><i /><i /></span>
            <span>Menu</span>
          </button>
          <nav id="site-navigation" className={open ? 'site-nav is-open' : 'site-nav'} aria-label="Primary navigation">
            {navItems.map(([to, label]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}
            {user ? (
              <>
                <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link>
                <a href="/" onClick={(event) => { event.preventDefault(); handleLogout(); }}>Log out</a>
              </>
            ) : (
              <a href="/admin" onClick={(event) => { event.preventDefault(); setOpen(false); setLoginOpen(true); }}>Owner login</a>
            )}
            <button className="button button-small" type="button" onClick={() => { setOpen(false); openConsultationModal(); }}>Free consultation</button>
          </nav>
        </div>
      </header>
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} onLogin={handleLogin} />
    </>
  );
}
